import { defaultTheme } from '@landr/maestro';

const getOpacityFromForegroundColor = (foregroundColor?: string) => {
    return foregroundColor === 'black'
        ? defaultTheme.opacities['subtle']
        : defaultTheme.opacities['overlay'];
};

export default getOpacityFromForegroundColor;
